import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

import TimelineItem from './item';

const Timeline = props => {
	const { logs, showMoreLogs, intl } = props;
	return (
		<div className="timeline-container">
			{logs.rows && logs.rows.length
				? logs.rows.map((item, i) => <TimelineItem key={i} item={item} {...props} />)
				: null}
			<div className="table-container__navigation">
				{logs.rows.length < logs.total &&
					<button className="ui-btn ui-btn-secondary" onClick={() => showMoreLogs()}>
						{intl('Show more')}
					</button>}
			</div>
		</div>
	);
};

Timeline.propTypes = {
	logs: PropTypes.object,
	showMoreLogs: PropTypes.func,
	intl: PropTypes.func
};

export default Timeline;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/timeline/main.js